<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="修改"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="12" :offset="6">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <el-form label-width="100px">
              <el-row>

                <el-col :span="24">
                  <validation-provider rules="required" name="是否客服" v-slot="{ errors }">
                    <el-form-item label="是否客服" :error="errors[0]">
                      <el-radio-group v-model="form.is_contact">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" :disabled="submitIng" @click="handleSubmit(onSubmit)">
                      {{ submitIng ? '提交中...' : '提交' }}
                    </el-button>
                    <el-button @click="closeHandle">取消</el-button>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
          </validation-observer>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: ''
      },
      form: {
        id: '',
        is_contact: 0,
      },
      submitIng: false,
      openStatus: false,
      selectIng: false
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {
  },
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.form = {
        admin_id: '',
        is_contact: 0,
      }
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminPeopleUpdateDetail(_this.query).then(res => {
        _this.openStatus = true;
        _this.loading = false;
        _this.form = JSON.parse(JSON.stringify(res.detail))
      }).catch(() => {
        _this.openStatus = false;
        _this.loading = false;
      })
    },
    onSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.form.id = _this.query.id;
      _this.$apiAdmin.adminPeopleUpdate(_this.form)
          .then((res) => {
            _this.submitIng = false;
            _this.$message.success('修改成功')
            _this.$emit('finish', {})
            _this.closeHandle();
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg)
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.form = {
        id: '',
        is_contact: 0,
      }
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>